//#region src/compat/util/stubArray.ts
function stubArray() {
	return [];
}
//#endregion
export { stubArray };
